import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Wrapper from '../wrapper/index'
import './style.scss'

class Section extends Component {
  static propTypes = {
    border: PropTypes.string,
    title: PropTypes.func,
    titleLink: PropTypes.string,
    text: PropTypes.string
  }

  render() {
    const {
      border,
      title = () => '',
      titleClass = '',
      titleLink = '',
      text = ''
    } = this.props

    const titleObj =
      title() !== '' ? (
        <h2 className={`section__title ${titleClass}`}>
          {titleLink !== '' ? <Link to={titleLink}>{title()}</Link> : title()}
        </h2>
      ) : null

    return (
      <section
        className={`section ${border === 'top' ? 'only-border-top' : ''} ${
          border === 'bottom' ? 'only-border-bottom' : ''
        } ${border === 'none' ? 'border-none' : ''} ${
          this.props.className ? this.props.className : ''
        }`}
        id={this.props.id}
      >
        <div className='section__inner section_pt30px'>
          <Wrapper>
            {titleObj}
            {text !== '' && text ? (
              <p
                className='section__text'
                dangerouslySetInnerHTML={{ __html: text }}
              />
            ) : null}
            {this.props.children}
          </Wrapper>
        </div>
      </section>
    )
  }
}

export default Section
